export enum AdjustTrackEvent {
  EPISODE_PUBLISHED = '9x0toq',
  ONBOARDING_COMPLETED = 'o3apzr',
  ONBOARDING_STARTED = 'w9h85q',
}
